// src/api/healthcare/Testing/CustomTestPackageApi.ts

import { ENV } from '../../../config/runtimeEnv';
import {
	CustomTestPackage,
	CustomTestPackageFilters,
	CreateCustomTestPackageRequest,
	UpdateCustomTestPackageRequest,
	ApiResponse,
} from "../../../types/healthcare/TestTypes";
import { http } from "../../../lib/http/client";

const HEALTHCARE_BASE_URL = ENV.VITE_HEALTHCARE_SERVER;

export const fetchCustomTestPackagesPublic = async (): Promise<CustomTestPackage[]> => {
	const response = await http.get(`${HEALTHCARE_BASE_URL}/public/custom-test-packages`);
	return response.data.data;
};

export const fetchCustomTestPackages = async (filters?: CustomTestPackageFilters): Promise<CustomTestPackage[]> => {
	const params = new URLSearchParams();

	if (filters?.category_id !== undefined) {
		params.append("category_id", filters.category_id.toString());
	}
	if (filters?.active_only !== undefined) {
		params.append("active_only", filters.active_only ? "1" : "0");
	}
	if (filters?.include_analysis_types !== undefined) {
		params.append("include_analysis_types", filters.include_analysis_types ? "1" : "0");
	}


	const response = await http.get(`${HEALTHCARE_BASE_URL}/custom-test-packages?${params.toString()}`);
	return response.data.data;
};

export const fetchCustomTestPackage = async (id: number): Promise<CustomTestPackage> => {
	const response = await http.get(`${HEALTHCARE_BASE_URL}/custom-test-packages/${id}`);
	return response.data.data;
};

export const createCustomTestPackage = async (data: CreateCustomTestPackageRequest): Promise<CustomTestPackage> => {
	const response = await http.post(`${HEALTHCARE_BASE_URL}/custom-test-packages`, data);
	return response.data.data;
};

export const updateCustomTestPackage = async (id: number, data: UpdateCustomTestPackageRequest): Promise<CustomTestPackage> => {
	const response = await http.put(`${HEALTHCARE_BASE_URL}/custom-test-packages/${id}`, data);
	return response.data.data;
};

export const deleteCustomTestPackage = async (id: number): Promise<{ message: string }> => {
	const response = await http.delete(`${HEALTHCARE_BASE_URL}/custom-test-packages/${id}`);
	return response.data;
};

export const toggleCustomTestPackageActive = async (id: number): Promise<CustomTestPackage> => {
	const response = await http.patch(
		`${HEALTHCARE_BASE_URL}/custom-test-packages/${id}/toggle-active`,
		{}
	);
	return response.data.data;
};


export const fetchCustomTestPackageFormConfig = async (id: number): Promise<ApiResponse<any>> => {
	const response = await http.get(`${HEALTHCARE_BASE_URL}/custom-test-packages/${id}/form-config`);
	return response.data;
};

export const reorderCustomTestPackages = async (
	packages: Array<{ id: number; sort_order: number }>
): Promise<ApiResponse<null>> => {
	const response = await http.post(
		`${HEALTHCARE_BASE_URL}/custom-test-packages/reorder`,
		{ packages }
	);
	return response.data;
};

export const bulkUpdateCustomTestPackages = async (
	packages: Array<{ id: number; is_active?: boolean; sort_order?: number }>
): Promise<CustomTestPackage[]> => {
	const response = await http.patch(
		`${HEALTHCARE_BASE_URL}/custom-test-packages/bulk-update`,
		{ packages }
	);
	return response.data.data;
};
